import { Typography } from '@mui/material'
import EmailSetup from '../../components/EmailSetup/EmailSetup'
import * as S from './EmailSettings.styles'

const EmailSettings = () => (
  <S.Wrapper>
    <Typography variant='h5' fontWeight='bold'> Configuração de E-mail </Typography>
    <EmailSetup />
  </S.Wrapper>
)

export default EmailSettings
